import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../../../../../utils/useFetch";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useState } from "react";
import { toast } from "react-hot-toast";

const ConfirmDeleteAddressModal = ({ showModal, address }: any) => {
  const userData = useSelector((state: RootState) => state.user.userInfo);
  const [isSendingData, setIsSendingData] = useState(false);

  const fetchDelete = async () => {
    const _formData = new FormData();
    _formData.append("address_id", address.id);
    _formData.append("code", userData.code);
    _formData.append("mobile", userData.mobile);

    const response = await fetch(API_BASE_URL + "newdeleteaddress", {
      method: "POST",
      body: _formData,
    }).then((res) => res.json());

    return response;
  };
  const handleConfirm = () => {
    setIsSendingData(true);
    fetchDelete().then((response) => {
      toast.success("آدرس حذف شد");
      setIsSendingData(false);
      showModal();
    });
  };
  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => showModal()}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'>{`حذف آدرس ${address.region}`}</div>
            <div>
              <button
                onClick={() => showModal()}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div className='p-2'>
            آیا از حذف آدرس{" "}
            <span className='text-rose-900'>{address.address}</span> در{" "}
            <span className='font-bold'>{address.region}</span> مطمئن هستید؟
          </div>

          <div className='p-2 border-t flex'>
            <button
              onClick={() => showModal()}
              className='rounded p-2 flex-1 bg-rose-900 text-white'
            >
              خیر
            </button>

            <button
              onClick={handleConfirm}
              disabled={isSendingData}
              className='flex-1 p-2 text-rose-900'
            >
              {isSendingData ? (
                <FontAwesomeIcon
                  icon={faCircleNotch}
                  className='rotate-animation'
                />
              ) : (
                "بله"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteAddressModal;
